/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GitFork(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224.00049,67.99756a36,36,0,1,0-44,35.09289v.9076a16.01865,16.01865,0,0,1-16,16l-72,.00146a15.99994,15.99994,0,0,1-16-16v-.90906a36,36,0,1,0-16,0v.90906a31.99909,31.99909,0,0,0,32,32L120.002,135.999l-.001,16.908a35.99993,35.99993,0,1,0,16,.00019l.001-16.90857,27.99854-.00055a32.0373,32.0373,0,0,0,32-32v-.9076A36.05514,36.05514,0,0,0,224.00049,67.99756ZM148.00049,188a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148.00049,188Z" />
    </Svg>
  );
}

export default GitFork;
